'use client';

import { type Resolver, useForm } from 'react-hook-form';
import { ActionButton, FormText, LinkButton } from '../../../../components/form';

import layoutStyles from '../../../../styles/modules/layout.module.scss';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
export interface AccountEditFormUIProps {
  name: string;
  onSubmit: (formData: FormData) => Promise<void>;
  onError: () => void;
  isLoading?: boolean;
  resolver?: Resolver<AccountEditFormData>;
}

export interface AccountEditFormData {
  name: string;
}

function AccountEditForm({ name, onSubmit, onError, isLoading = false, resolver }: AccountEditFormUIProps) {
  const { handleSubmit, getValues, control } = useForm<AccountEditFormData>({
    mode: 'onChange',
    defaultValues: {
      name: name,
    },
    resolver,
  });

  const submit = async () => {
    try {
      const formData = new FormData();
      formData.append('name', getValues('name'));
      await onSubmit(formData);
      // biome-ignore lint/correctness/noUnusedVariables: <explanation>
    } catch (error) {
      onError();
    }
  };

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <div className={layoutStyles.formWrapper}>
        <FormText label='名前' name='name' control={control} required />
      </div>
      <div className={`${layoutStyles.centeredBtnWrapper} ${utilsStyles.mtMedium}`}>
        <ActionButton onClick={handleSubmit(submit, onError)} disabled={isLoading}>
          変更内容を保存する
        </ActionButton>
        <LinkButton href='/' outlined>
          キャンセル
        </LinkButton>
      </div>
    </form>
  );
}

export default AccountEditForm;
